// getFlixBadgeColor.js
'use strict';
import { Collection } from 'immutable';

import createCachedSelector from '../resource/createCachedSelector.js';

import { getMergedRemoteConfig } from '../selector/getRemoteConfigData.js';
import { MESSAGE_BADGE_NONE } from '../RemoteConfigKeys.js';

/**
 * Select flix badge color by badge name
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} badgeName - badge name.
 * @return {string} The selected flix badge color.
 */
const getFlixBadgeColor = createCachedSelector(
  state => getMergedRemoteConfig(state),
  (state, badgeName) => badgeName,
  (remoteConfig, badgeName) => {
    const flixBadgesKey = remoteConfig?.filter((value, key) => {
      return /^MESSAGE_BADGE_/.test(key) && key !== MESSAGE_BADGE_NONE;
    });

    return flixBadgesKey.reduce((result, value, key) => {
      if (result) return result;
      const color = key.replace('MESSAGE_BADGE_', '');
      const raw = remoteConfig.get(key);
      const normalized = raw instanceof Collection ? raw.toJS() : raw;
      const badgeColorList = Array.isArray(normalized)
        ? normalized
        : typeof normalized === 'string'
          ? normalized.split(' ')
          : [];

      return badgeColorList.includes(badgeName) ? color : result;
    }, '');
  }
)((state, badgeName) => `${badgeName}`);

export default getFlixBadgeColor;
